import React from 'react'

import styles from '../../../components/common/styled/Buttons.module.scss'
import {QueryStatus} from '../../../containers/QueryBuilder/types/Query'
import {Button, Tooltip} from 'antd';

import {ReactComponent as ExpandIcon} from '../icons/Expand.svg';
import {ReactComponent as CollapseIcon} from '../icons/Collapse.svg'
import {UserQuery} from '../../../containers/QueryBuilder/types/UserQuery'

interface ResultTableResizeButtonProps {
    userQuery: UserQuery
    isExpanded: boolean
    toggleCollapse: () => void
    isQueryResultAvailable?: boolean
}

const ResultTableResizeButton = ({userQuery, isExpanded, toggleCollapse, isQueryResultAvailable}: ResultTableResizeButtonProps) => {

    const isResultReady = userQuery.status === QueryStatus.FINISHED

    if(isQueryResultAvailable) {
        return <>
            <div className={styles.resultTableResizeContainer}>
                <Tooltip title={isExpanded ? 'Collapse Result Table' : 'Expand Result Table'}>
                    <Button onClick={toggleCollapse}
                            type='text'
                            disabled={!isResultReady}
                            icon={isExpanded ? <CollapseIcon data-testid = 'test-collapse' /> : <ExpandIcon data-testid = 'test-expand' />}
                            data-testid={'expand-collapse-button'}
                            className={styles.resultTableResizeButton}
                    />
                </Tooltip>
            </div>
        </>
    } else {
        return <></>
    }

}

export default ResultTableResizeButton